module.exports = __webpack_public_path__ + "img/logika_logo.cefca723.svg";